<section class="shop-page section-main-padding">
  <h1 class="page-title">Our Shop</h1>
  <div class="products-grid">
    <app-product-card *ngFor="let product of products" [product]="product"></app-product-card>
  </div>
</section>